export class NeqTableRequest {
    pageIndex: number;
    nbElementsParPage: number;
    tri: NeqTableSort[];
    filters: NeqTableConvertFilter[];
}

export interface NeqTableConvertFilter {
  value: any;
  key: string;
}

export class NeqTableSort {
    field: string;
    asc: boolean;
}

export class NeqTableFilterAndSort {
    filter: NeqTableFilter[];
    tri: NeqTableSort[];
    date: NeqTableSortDate[];
}

export class NeqTableFilter {
    field: string;
    filtre: string;
}

export class NeqTableSortDate {
    field: string;
    from: Date;
    to: Date;
}
